export const normalizeResidence = (residence) => {
	let attributes = residence.attributes

	return {
		id: residence.id,
		type: attributes.type,
		surface: parseInt(attributes.surface, 10),
		hasPets: attributes.pets,
		howToGetIn: attributes.how_to_get_in,
		otherInfo: attributes.other_info,
		address: {
			streetName: attributes.address.street_name,
			streetNumber: attributes.address.street_number,
			streetBox: attributes.address.street_box,
			zipCode: attributes.address.zip_code,
			city: attributes.address.town
		}
	}
}


// WEBPACK FOOTER //
// ./src/normalizers/residenceNormalizer.js